var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form-radio-group",
        {
          attrs: { stacked: "" },
          model: {
            value: _vm.selectedFixing,
            callback: function ($$v) {
              _vm.selectedFixing = $$v
            },
            expression: "selectedFixing",
          },
        },
        [
          _c(
            "b-form-radio",
            {
              staticClass: "mb-2",
              attrs: { value: "hanger", disabled: _vm.isHangerDisabled },
            },
            [
              _c("strong", [_vm._v("Easy Hanger ")]),
              _vm._v("+ £0.00 "),
              _c("em", [_vm._v('(included in price, up to 20x16")')]),
            ]
          ),
          _c("b-form-radio", { attrs: { value: "string" } }, [
            _c("strong", [_vm._v("D-rings and String ")]),
            _vm._v(_vm._s(_vm.diffInPrice)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }